import api from './api';

export interface FAQ {
  id: number;
  questionAr: string;
  questionEn: string;
  answerAr: string;
  answerEn: string;
  displayOrder: number;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: {
    id: number;
    name: string;
  };
}

export interface CreateFAQRequest {
  questionAr: string;
  questionEn: string;
  answerAr: string;
  answerEn: string;
  displayOrder?: number;
  isActive?: boolean;
}

export interface UpdateFAQRequest {
  questionAr?: string;
  questionEn?: string;
  answerAr?: string;
  answerEn?: string;
  displayOrder?: number;
  isActive?: boolean;
}

export interface FAQListResponse {
  success: boolean;
  faqs: FAQ[];
  count: number;
}

// Public APIs
export const faqPublicApi = {
  // Get all active FAQs
  getAll: async (): Promise<FAQ[]> => {
    const response = await api.get('/faqs');
    return Array.isArray(response.data) ? response.data : [];
  },

  // Get FAQ by ID
  getById: async (id: number): Promise<FAQ> => {
    const response = await api.get(`/faqs/${id}`);
    return response.data;
  },
};

// Admin APIs
export const faqAdminApi = {
  // Get all FAQs (including inactive)
  getAll: async (): Promise<FAQListResponse> => {
    const response = await api.get('/admin/faqs');
    const data = response.data;
    
    // Handle both response formats
    if (data.success && data.faqs) {
      return data;
    }
    
    // If response is just an array, wrap it
    if (Array.isArray(data)) {
      return {
        success: true,
        faqs: data,
        count: data.length,
      };
    }
    
    return {
      success: true,
      faqs: [],
      count: 0,
    };
  },

  // Create FAQ
  create: async (data: CreateFAQRequest): Promise<FAQ> => {
    const response = await api.post('/admin/faqs', data);
    return response.data.faq || response.data;
  },

  // Update FAQ
  update: async (id: number, data: UpdateFAQRequest): Promise<FAQ> => {
    const response = await api.put(`/admin/faqs/${id}`, data);
    return response.data.faq || response.data;
  },

  // Delete FAQ
  delete: async (id: number): Promise<void> => {
    await api.delete(`/admin/faqs/${id}`);
  },
};

